
document.addEventListener('DOMContentLoaded', () => {
  function applyExpressRewardIfNeeded() {
    const expressPrize = document.querySelector('.express-prize');
    const activeDiscount = sessionStorage.getItem('activeDiscountCode');

    if (expressPrize) {
      expressPrize.classList.toggle('active', activeDiscount === 'XMASEXPRESS');
    }
  }
  applyExpressRewardIfNeeded();
  const observer = new MutationObserver(() => {
    applyExpressRewardIfNeeded();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  watchDiscountChanges();
});

function watchDiscountChanges() {
  const CHECK_DELAY = 3200;
  const wrapper = document.querySelector('.styles_Footer__savings__');

  if (!wrapper) return;

  const discountObserver = new MutationObserver(() => {
    setTimeout(() => {
      validateDiscountStillExists();
    }, CHECK_DELAY);
  });

  discountObserver.observe(wrapper, {
    childList: true,
    subtree: true
  });
}

function validateDiscountStillExists() {
  const activeDiscountCode = sessionStorage.getItem('activeDiscountCode');
  const bonusProductData = JSON.parse(sessionStorage.getItem('bonusProduct') || 'null');
  if (!activeDiscountCode) return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const discountStillExists = cart.cart_level_discount_applications?.some(
        d => d.code === activeDiscountCode
      );

      if (!discountStillExists) {
        console.log(`[Flipper] Discount ${activeDiscountCode} removed. Clearing session + bonus.`);
        sessionStorage.removeItem('activeDiscountCode');
        sessionStorage.removeItem('bonusProduct');
        const expressPrize = document.querySelector('.express-prize');
        if (expressPrize) expressPrize.classList.remove('active');

        if (bonusProductData?.discountCode === activeDiscountCode) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: bonusProductData.productId, quantity: 0 })
          }).then(() => {
            if (window.UpCart) UpCart.refreshCart();
            console.log(`[Flipper] Removed bonus product ID ${bonusProductData.productId}`);
          });
        }
      }
    })
    .catch(err => console.warn('Error verifying cart discount:', err));
}

function monitorBonusRewardSync() {
  const CHECK_INTERVAL = 3600;

  setInterval(() => {
    const bonusData = JSON.parse(sessionStorage.getItem('bonusProduct') || 'null');
    const activeDiscountCode = sessionStorage.getItem('activeDiscountCode');

    if (!bonusData) return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const discounts = cart.cart_level_discount_applications || [];
        const items = cart.items || [];

        const discountStillExists = discounts.some(d => d.code === bonusData.discountCode);
        const bonusStillInCart = items.some(item => item.variant_id == bonusData.productId);

        // 💥 CASE 1: Discount exists but product was manually removed
        if (discountStillExists && !bonusStillInCart) {
          console.log('[Flipper] Bonus product manually removed. Clearing bonusProduct from session.');
          sessionStorage.removeItem('bonusProduct');
          return;
        }

        // 💥 CASE 2: Discount gone but product still in cart → remove product
        if (!discountStillExists && bonusStillInCart) {
          console.log('[Flipper] Discount missing but bonus product still in cart. Removing product.');

          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: bonusData.productId, quantity: 0 })
          }).then(() => {
            if (window.UpCart) UpCart.refreshCart();
            sessionStorage.removeItem('bonusProduct');
            sessionStorage.removeItem('activeDiscountCode');

            const expressPrize = document.querySelector('.express-prize');
            if (expressPrize) expressPrize.classList.remove('active');
          }).catch(err => console.warn('❌ Failed to remove bonus product:', err));
        }
      })
      .catch(err => console.warn('❌ Failed to check cart for cleanup:', err));
  }, CHECK_INTERVAL);
}


/* ----------------------------------------------------
   SAFE MASTER REWARD ENFORCER (retry-friendly)
---------------------------------------------------- */

let flipperEnforcerLock = false;

async function enforceSingleRewardState() {
  if (flipperEnforcerLock) return;
  flipperEnforcerLock = true;

  try {
    const activeCode = sessionStorage.getItem('activeDiscountCode');
    const bonus = JSON.parse(sessionStorage.getItem('bonusProduct') || 'null');

    let cart;

    try {
      cart = await fetch('/cart.js', { method: 'GET', credentials: 'same-origin' })
        .then(r => {
          if (!r.ok) throw new Error("Cart fetch failed");
          return r.json();
        });
    } catch (err) {
      console.warn("[Flipper] Could not read cart for enforcement — retrying in 800ms");

      // Retry later — Shopify not ready yet
      flipperEnforcerLock = false;
      setTimeout(enforceSingleRewardState, 800);
      return;
    }

    const cartDiscount = cart.cart_level_discount_applications?.[0]?.code || null;
    const hasBonusProduct = bonus && cart.items.some(i => i.variant_id == bonus.productId);

    /* CASE 1 — No active session reward */
    if (!activeCode) {
      if (cartDiscount || hasBonusProduct) {
        console.log("[Enforcer] No reward active → clearing cart extras");

        await clearAllDiscounts();

        if (hasBonusProduct) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: bonus.productId, quantity: 0 })
          });
        }
      }
      flipperEnforcerLock = false;
      return;
    }

    /* CASE 2 — Discount mismatch */
    if (cartDiscount && cartDiscount !== activeCode) {
      console.log(`[Enforcer] Removing WRONG discount ${cartDiscount}, keeping ${activeCode}`);
      await clearAllDiscounts();
    }

    /* CASE 3 — Bonus product mismatch */
    if (hasBonusProduct && bonus.discountCode !== activeCode) {
      console.log("[Enforcer] Bonus product does NOT match active reward → removing");

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: bonus.productId, quantity: 0 })
      });

      sessionStorage.removeItem('bonusProduct');
    }

  } catch (err) {
    console.warn("[Flipper] Enforcer crashed:", err);
  }

  flipperEnforcerLock = false;
}
